import { l as u } from "../transform-DVGbLiBW.js";
import "../type-Dku6Xzl6.js";
function c(e) {
  const r = Object.keys({
    className: !0,
    containerRef: !0,
    inputSectionRef: !0,
    label: !0,
    icons: !0,
    input: !0,
    actions: !0,
    hint: !0,
    error: !0,
    errorOnTooltip: !0,
    disabled: !0,
    readOnly: !0,
    changed: !0,
    required: !0,
    variant: !0,
    withAsterisk: !0,
    spacing: !0
  }), o = u(
    r,
    (t) => t,
    (t) => e[t]
  ), n = {
    ...e
  };
  return r.forEach((t) => {
    delete n[t];
  }), [o, n];
}
export {
  c as extractInputContainerProps
};
